import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  projectId: process.env.REACT_APP_PROJECTID,
  storageBucket: process.env.REACT_APP_STORAGEBUCKET_FIREBASE,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_MEASUREMENTID,
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// Handle foreground push notifications
onMessage(messaging, (payload) => {
  // console.log("Message received:", payload);

  // Preload and play sound when the user has interacted
  const playSound = () => {
    const audio = new Audio("/belinda.mp3"); // Ensure correct path
    audio.play().catch((error) => console.error("Audio play failed:", error));
  };

  // Request notification permission
  if (Notification.permission === "granted") {
    const notificationTitle = payload.notification?.title || "New Message";
    const notificationOptions = {
      body: payload.notification?.body || "You have a new message",
      icon: "https://static.meragoapp.com/images/menuLogo.png", // Ensure correct path
      sound: "/belinda.mp3",
    };

    const notification = new Notification(
      notificationTitle,
      notificationOptions
    );

    // Redirect to the specified URL when the notification is clicked
    notification.onclick = function() {
      playSound(); // Play sound when notification is clicked
      window.open(process.env.REACT_APP_NOTIFICATION_HOME, "_blank"); // Open URL in a new tab
    };
  }
});

export { messaging, getToken };
